<template>
  <group-buy-block class="group-buy-rule"
                   title="拼团须知"
  >
    <template #list>
      <div class="rule-list" v-html="rule"></div>
    </template>
  </group-buy-block>
</template>

<script>
  import GroupBuyBlock from '@/pages/GroupBuy/components/DetailBlock';

  export default {
    name: 'GroupBuyDetailRule',
    components: {
      GroupBuyBlock,
    },
    props: {
      rule: {
        type: String,
        required: true,
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .rule-list {
    color: @color-text-light;
    font-size: @font-size-base;
    line-height: 2;
    margin: 0;
    padding: @size-base 0;
    list-style: none;
    overflow: scroll;
  }
</style>
